import React from "react";
import "./blogBox.scss";

const BlogBox = (props) => {
  return (
    <div className="blog__box">
      <a
        href={props.article.url} // ✅ use "url" from Blog.js
        target="_blank"
        rel="noopener noreferrer"
        className="blog__image-link"
        style={{ textDecoration: "none" }}
      >
        <div className="blog__image" style={{ position: "relative" }}>
          <img
            src={props.article.image}
            alt={props.article.title}
            style={{ width: "100%", height: "auto", objectFit: "contain" }}
          />
          <div
            className="blog__hover flex-center"
            style={{
              cursor: "pointer",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          >
            <h4 className="font30 weight800">READ MORE</h4>
          </div>
        </div>
      </a>

      <div className="blog__info">
        <h4 className="font15 weight800">{props.article.title}</h4>
        <p className="font12 weight500 padding10">
          {props.article.description}
        </p>
        <p className="font12 weight500">{props.article.date}</p>
      </div>
    </div>
  );
};

export default BlogBox;
